export { CallsTabs } from './CallsTabs';
export type { TabItem } from './types';
export { PENDING_HUMAN_CALL_TAB_ID } from './types';
